export default __webpack_public_path__ + "static/media/honeycomb.5755a561.png";